import { useEffect, useState } from "react";
import { toast } from "sonner";
import { ShieldCheck, ShieldAlert, Shield } from "lucide-react";
import api from "@/lib/api";
import { useLang } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

export default function VerificationCard() {
  const { t } = useLang();
  const [state, setState] = useState(null);
  const [dlg, setDlg] = useState(false);
  const [form, setForm] = useState({ vat_number: "", business_name: "", municipality: "", declaration: false });
  const load = () => api.get("/verification/mine").then((r) => setState(r.data)).catch((e) => console.error("verification load", e));
  useEffect(() => { load(); }, []);
  const submit = async () => {
    try { await api.post("/verification/submit", form); toast.success(t("dash.pending_verify")); setDlg(false); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || t("dash.toast_error")); }
  };
  const s = state?.status || "none";
  const map = {
    verified: { icon: ShieldCheck, cls: "bg-sage text-white", label: t("dash.verified") },
    pending: { icon: ShieldAlert, cls: "bg-yellow-500/20 text-yellow-800", label: t("dash.pending_verify") },
    rejected: { icon: Shield, cls: "bg-destructive/10 text-destructive", label: t("dash.not_verified") },
    none: { icon: Shield, cls: "bg-muted text-muted-foreground", label: t("dash.not_verified") },
  }[s];
  const Icon = map.icon;
  return (
    <div className="border border-border rounded-lg p-5 bg-card" data-testid="verify-card">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2"><Icon className="w-4 h-4 text-sage"/><span className="uppercase tracking-[0.2em] text-[10px] text-muted-foreground">{t("dash.verify_title")}</span></div>
        <span className={`text-xs px-2 py-1 rounded-full ${map.cls}`} data-testid="verify-status">{map.label}</span>
      </div>
      <p className="text-xs text-muted-foreground mb-4">{t("dash.verify_hint")}</p>
      {s !== "verified" && s !== "pending" && (
        <Dialog open={dlg} onOpenChange={setDlg}>
          <DialogTrigger asChild>
            <Button size="sm" className="w-full bg-primary text-primary-foreground hover:bg-primary/90 lift" data-testid="verify-open-btn">{t("dash.submit_verify")}</Button>
          </DialogTrigger>
          <DialogContent>
            <DialogHeader><DialogTitle>{t("dash.submit_verify")}</DialogTitle></DialogHeader>
            <div className="space-y-3">
              <div><Label>{t("dash.business_name")}</Label><Input value={form.business_name} onChange={(e) => setForm({ ...form, business_name: e.target.value })} data-testid="verify-biz"/></div>
              <div><Label>{t("dash.vat_number")}</Label><Input value={form.vat_number} onChange={(e) => setForm({ ...form, vat_number: e.target.value })} data-testid="verify-vat"/></div>
              <div><Label>{t("dash.municipality")}</Label><Input value={form.municipality} onChange={(e) => setForm({ ...form, municipality: e.target.value })}/></div>
              <label className="flex items-start gap-2 text-xs text-muted-foreground">
                <input type="checkbox" checked={form.declaration} onChange={(e) => setForm({ ...form, declaration: e.target.checked })} data-testid="verify-decl"/>
                <span>{t("dash.declaration")}</span>
              </label>
              <Button onClick={submit} disabled={!form.declaration || !form.vat_number} className="w-full bg-primary text-primary-foreground hover:bg-primary/90 lift" data-testid="verify-submit-btn">{t("dash.submit_verify")}</Button>
            </div>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
}
